import { render, staticRenderFns } from "./CurriculumsQuery.vue?vue&type=template&id=6c2aea8d&lang=pug"
import script from "./CurriculumsQuery.vue?vue&type=script&lang=js"
export * from "./CurriculumsQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports